import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function MoneyBackGuarantee() {
  return <section className="w-full bg-white py-16" data-id="element-497">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-498">
        <div className="bg-emerald-50 rounded-xl p-8 md:p-12 text-center" data-id="element-499">
          <ShieldCheckIcon className="w-16 h-16 text-emerald-700 mx-auto mb-6" data-id="element-500" />
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-501">
            30-Day Money-Back Guarantee
          </h2>
          <p className="text-xl text-stone-700 leading-relaxed" data-id="element-502">
            If you're not fully satisfied, email us for a full refund — no
            questions asked.
          </p>
        </div>
      </div>
    </section>;
}